import Model from "./model";

export default new Model({
  resource: "remuneracion",
  //no CRUD
  inputs:[]

});
